


export enum CollarTypeEnum {
	withBuckle = 'Límec se zapínáním',
	withoutBuckle = 'Límec bez zapínání',
}


export const COLLAR_TYPE_ENUM_TRANSLATION_KEYS = {
	[CollarTypeEnum.withBuckle]: 'collarType.collarTypeEnum.withBuckle',
	[CollarTypeEnum.withoutBuckle]: 'collarType.collarTypeEnum.withoutBuckle',
} as const;


export const isCollarTypeEnum = (value: unknown): value is CollarTypeEnum => {
	const enumValues = Object.values(CollarTypeEnum);
	return typeof value === 'string' && enumValues.includes(value as CollarTypeEnum);
};